import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { areUrlPathsEqual } from '../../../modules/utils';
import type { TabProps } from './types';
import cn from '~modules/cn';
import './tab.scss';

export const Tab = ({ url, id, className, exact, children, active, onChange, onClick, disabled, tipText }: TabProps): JSX.Element => {
    const handleClick = () => {
        if (!disabled && onChange && id) {
            onChange(id);
        }

        if (!disabled && onClick) {
            onClick();
        }
    };
    return (
        <>
            {url && (
                <NavLink
                    exact={exact}
                    to={{
                        pathname: url
                    }}
                    isActive={(_match, location) => areUrlPathsEqual(url, location.pathname + location.hash)}
                    onClick={handleClick}
                    className={cn(className, 'tab-container', { 'tab-container--disabled': disabled })}
                    activeClassName="tab-container--active"
                    data-tip={tipText}
                    data-tip-placement="top"
                >
                    {children}
                </NavLink>
            )}
            {id && (
                <button
                    className={cn(className, 'tab-container', { active }, { 'tab-container--disabled': disabled })}
                    onClick={handleClick}
                    data-tip={tipText}
                    data-tip-placement="top"
                    aria-pressed={active}
                >
                    {children}
                </button>
            )}
        </>
    );
};
